import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '@/locales/en.json';
import ar from '@/locales/ar.json';

/**
 * DO NOT read localStorage for initial language here.
 *
 * During the SSG (static site generation) prerender pass, localStorage is null,
 * so reading it would hard-code every route as lang="en" in the prerendered HTML.
 * Locale must instead be derived from the route pathname by LocaleLayout at
 * render time, which allows the build to emit both lang="en" and lang="ar" HTML.
 *
 * LocaleLayout creates and passes language-specific i18n instances, so the
 * singleton is only used for resource registration, not language selection.
 */
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: 'en', // Temporary fallback; LocaleLayout will override with cloned instances
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
